// extracted by mini-css-extract-plugin
module.exports = {"inputPrepend":"SearchByColumn_inputPrepend__3fVRf","span":"SearchByColumn_span__2QTFf"};